// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RXKEq","textarea":"styles_textarea__1DnGr"};